import React from "react"
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { Button } from "./button";
import { CheckIcon, ChevronsUpDownIcon, FolderIcon } from "lucide-react";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator } from "./command";
import { cn } from "@/lib/utils";

export function Combobox({
    options,
    value,
    onChange,
    emptyText = 'Aucun element trouvé.',
    searchText = 'Rechercher un element...',
    selectText = 'Selectionner un element ...'
}) {
    const [open, setOpen] = React.useState(false)
    const [width, setWidth] = React.useState(false)
    const buttonRef = React.useRef()

    React.useLayoutEffect(() => {
        if (buttonRef.current) {
            setWidth(buttonRef.current.offsetWidth)
        }
    }, [buttonRef])

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    ref={buttonRef}
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className="w-full flex rounded-xl items-center"
                >
                    <div className="flex-grow flex items-center justify-start">
                        <FolderIcon className="mr-2 w-4 l-4" />

                        {value
                            ? options.find((d) => d.value === value)?.label
                            : selectText}
                    </div>
                    <ChevronsUpDownIcon className="opacity-50" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="p-0 rounded-xl overflow-hidden" style={{ width }}>
                <Command>
                    <CommandInput placeholder={searchText} className="h-9" />
                    <CommandList>
                        <CommandEmpty>{emptyText}</CommandEmpty>
                        <CommandGroup>
                            {options.map((option) => option.separator ? (<CommandSeparator />) : (
                                <CommandItem
                                    key={option.value}
                                    value={option.value}
                                    onSelect={(currentValue) => {
                                        onChange(currentValue)
                                        setOpen(false)
                                    }}
                                >
                                    {option.label}
                                    <CheckIcon
                                        className={cn(
                                            "ml-auto",
                                            value === option.value ? "opacity-100" : "opacity-0"
                                        )}
                                    />
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    )
}